import { MutableRefObject, RefObject, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { ReactFlowInstance } from 'reactflow';
import { useResizeObserver } from 'usehooks-ts';

import { changeScreenPosition } from '../../../features/ui/uiSlice';

// component state to keep dragging and dimension-resizing concerns outside of Redux
export const useResizeHelper = (
  reactFlowRef: RefObject<HTMLDivElement>,
  instanceRef: MutableRefObject<ReactFlowInstance<any, any> | null>
) => {
  const dispatch = useDispatch();

  // when react flow element resizes, keep the Redux UI state in sync
  const handleViewPositionChange = useCallback(() => {
    if (instanceRef?.current === null || reactFlowRef.current === null) {
      return;
    }

    const { screenToFlowPosition, getZoom } = instanceRef.current;

    const { clientWidth: width, clientHeight: height } = reactFlowRef.current;

    dispatch(
      changeScreenPosition({
        position: screenToFlowPosition({ x: width / 2, y: height / 2 }),
        zoom: getZoom(),
      })
    );
  }, [dispatch, instanceRef, reactFlowRef]);

  useResizeObserver({
    ref: reactFlowRef,
    onResize: handleViewPositionChange,
  });

  return {
    handleViewPositionChange,
  };
};
